import Decimal from "decimal.js";
import { assertIsDecimalFinite } from "../number/assertIsDecimalFinite";

export function createFiniteDecimalFromAnyString(
  input: string,
  fieldName: string
): Decimal {
  const value = new Decimal(input.trim());
  assertIsDecimalFinite(value, fieldName);
  return value;
}
